import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SplashPage from '../components/SplashPage';
import settings from '../settings';

const SetInitialPassword = () => {
	const { token } = useParams();

	useEffect(() => {
		const redirectToSetInitialPassword = () => {
			const redirectUrl = `${settings.authority}/account/setpassword/${token}`;
			window.location.assign(redirectUrl);
		};

		redirectToSetInitialPassword();
	}, []);

	return <SplashPage waiting>Redirecting...</SplashPage>;
};

export default SetInitialPassword;
